import app from '../../angular_app.es6';
import { waitForNextButtonMessage } from '../../../approach-react/express/admin/common/navigation';

app.controller('SetupController', [ '$scope', 'Notification', '$timeout', '$element', '$rootScope', '$uibModal',
  ($scope, Notification, $timeout, $element, $rootScope, $uibModal) => {
    $scope.form = {};
    $scope.options = {};
    $scope.loading = false;

    $scope.init = (data, options, notification) => {
      $scope.form = data;
      $scope.options = options;
      if (notification) {Notification.error(notification);}
    };

    $scope.submitForm = () => {
      $element.parent().submit();
    };

    $scope.$on('project-form-next-step', $scope.submitForm);

    // when it becomes react-based, onlyCustom should be null
    waitForNextButtonMessage($scope.submitForm, true);

    $scope.deleteImage = (event) => {
      event.preventDefault();
      $scope.form.image_data = null;
      $scope.form.image_src = null;
    };

    $scope.onImageSelected = (file) => {
      $scope.loading = true;
      $rootScope.$broadcast('disableNavButtons');
    };

    $scope.onImageUploaded = (result) => {
      $scope.loading = false;
      $rootScope.$broadcast('enableNavButtons');
    };
  } ]);
